import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Check, X } from 'lucide-react';
export function WhoIsThisForSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-231">
      <div className="max-w-6xl mx-auto" data-id="element-232">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-233">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-234">
            <Card className="h-full border-2 border-green-500/20 bg-green-50/30" data-id="element-235">
              <h3 className="text-2xl font-bold mb-8 text-foreground" data-id="element-236">
                This is for you if:
              </h3>
              <ul className="space-y-6" data-id="element-237">
                <li className="flex items-start gap-4" data-id="element-238">
                  <div className="bg-green-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-239">
                    <Check className="w-5 h-5 text-green-600" data-id="element-240" />
                  </div>
                  <span className="text-lg text-foreground/80" data-id="element-241">
                    Your child is 2–3 years old and daycare/Pre-K is coming fast
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-242">
                  <div className="bg-green-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-243">
                    <Check className="w-5 h-5 text-green-600" data-id="element-244" />
                  </div>
                  <span className="text-lg text-foreground/80" data-id="element-245">
                    You're done spending $80–$100/month on diapers
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-246">
                  <div className="bg-green-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-247">
                    <Check className="w-5 h-5 text-green-600" data-id="element-248" />
                  </div>
                  <span className="text-lg text-foreground/80" data-id="element-249">
                    You need a method that works in the real world—in one
                    weekend
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-250">
                  <div className="bg-green-100 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-251">
                    <Check className="w-5 h-5 text-green-600" data-id="element-252" />
                  </div>
                  <span className="text-lg text-foreground/80" data-id="element-253">
                    You want a direct, practical approach (no fluff, no shame)
                  </span>
                </li>
              </ul>
            </Card>
          </motion.div>

          {/* NOT For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-254">
            <Card className="h-full border border-border bg-accent/20" data-id="element-255">
              <h3 className="text-2xl font-bold mb-8 text-foreground/60" data-id="element-256">
                This is not for:
              </h3>
              <ul className="space-y-6" data-id="element-257">
                <li className="flex items-start gap-4" data-id="element-258">
                  <div className="bg-muted rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-259">
                    <X className="w-5 h-5 text-muted-foreground" data-id="element-260" />
                  </div>
                  <span className="text-lg text-foreground/60" data-id="element-261">
                    Parents who aren't willing to give their child 3 days of
                    focused attention
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-262">
                  <div className="bg-muted rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-263">
                    <X className="w-5 h-5 text-muted-foreground" data-id="element-264" />
                  </div>
                  <span className="text-lg text-foreground/60" data-id="element-265">
                    Anyone looking for a "maybe in a few months" gentle approach
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-266">
                  <div className="bg-muted rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-267">
                    <X className="w-5 h-5 text-muted-foreground" data-id="element-268" />
                  </div>
                  <span className="text-lg text-foreground/60" data-id="element-269">
                    Children with medical conditions that require specific
                    pediatric guidance
                  </span>
                </li>
              </ul>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>;
}